import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { cloneDeep } from "lodash"

import { bindActionCreators } from "redux"
import { ActionCreators } from "../../../../redux/actions"
import PanelFooter from "../../../../components/panel/PanelFooter"
import PanelHeader from "../../../../components/panel/PanelHeader"
import PanelMenu from "../../../../components/panel/PanelMenu"
import MagicDragElement from "../../../../components/dragndrop/MagicDragElement"
import PH from "../../../../lib/PanelHelper"

class PreviewRequest extends Component {
  constructor(props) {
    super(props)

    this.state = {
      pages: props.pages,
      options: props.options,
      postData: {},
      validated: {},
    }
  }

  componentDidMount() {
    const {
      panelOpen: { index },
      panelData,
      getSuggestions,
    } = this.props
    const { pages, validated } = this.state

    if (typeof panelData !== "undefined") {
      this.setState({
        postData: panelData,
      })
    }

    // TODO: if object has prod that it does not need to be validated
    if (!validated[index]) {
      if (pages[index].options.validated) {
        this.setSubPageValidated(index, pages[index].options.validated)
      } else {
        this.setSubPageValidated(index, false)
      }
    }

    getSuggestions()
  }

  onUpdate = (obj) => {
    const { postData } = this.state

    const nPostData = cloneDeep(postData)

    Object.entries(obj).forEach(([key, val]) => {
      if (val) {
        nPostData[key] = val
      } else {
        delete nPostData[key]
      }
    })

    this.setState({
      postData: nPostData,
    })
  }

  onSubmit = () => {
    const { addRequestToSchedule } = this.props

    addRequestToSchedule(this.state.postData)
  }

  setSubPageValidated = (index, isValidated) => {
    const validated = cloneDeep(this.state.validated)

    validated[index] = isValidated

    this.setState({
      validated,
    })
  }

  getPage = (index, pages, postData) =>
    PH.getPage(
      index,
      pages[index],
      (val, type) => this.onUpdate(val, type),
      (i, val) => this.setSubPageValidated(i, val),
      postData
    )

  onClose = () => {
    const { clearPreviewSelection, closePanel, clearRequestToRemove, setViewFilter } = this.props

    clearPreviewSelection()
    closePanel()
    clearRequestToRemove()

    setTimeout(() => {
      setViewFilter({})
    }, 10)
  }

  render() {
    const { pages, validated, postData } = this.state
    const {
      panelOpen: { index },
    } = this.props

    return (
      <>
        <MagicDragElement key={"MagincDragElement"} bounds="" objectToMove="ReactModal__Content--free">
          Move
        </MagicDragElement>
        <PanelHeader key={"PanelHeader"} />
        <PanelMenu key={"PanelMenu"} />
        <div key={"Panel__Page"} className="Panel__Page  Panel--Preview">
          <div className="Panel__Page-Container PanelContent">{this.getPage(index, pages, postData)}</div>
          <PanelFooter
            index={index}
            data={pages[index]}
            validated={validated[index]}
            onClose={this.onClose}
            onSubmit={(val) => this.onSubmit(val)}
          />
        </div>
      </>
    )
  }
}

PreviewRequest.propTypes = {
  panelOpen: PropTypes.object,
  openPanelWithType: PropTypes.func,
  panelData: PropTypes.object,
  createNewRig: PropTypes.func,
  getSuggestions: PropTypes.func,
  addRequestToSchedule: PropTypes.func,
  clearPreviewSelection: PropTypes.func,
  closePanel: PropTypes.func,
  clearRequestToRemove: PropTypes.func,
  setViewFilter: PropTypes.func,
  options: PropTypes.object,
  pages: PropTypes.array,
  index: PropTypes.number,
  rigData: PropTypes.object,
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch)
}

function mapStateToProps(state) {
  return {
    panelOpen: state.application.panelOpen,
    panelData: state.application.panelData,
    rigData: state.schedulerData.schedulerData.data,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PreviewRequest)
